export enum TreeGatewayTag {
    None = 0,
    Area = 1,
    Environment = 2,
    Device = 3,
    Address = 4
}